import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';
import { Link } from 'react-router-dom';
import { UserContext } from '../utils/UserContext';


import { clearLocalStorage } from '../utils/utils';
import { PROJECT_TITLE } from '../utils/constants';


const pages = [
  {
    title : 'Reservation Types',
    link : '/reservation-type',
    isAdmin: true
  },{
    title : '  Reservations',
    link : '/',
    isAdmin: false
  },{
    title : 'Users',
    link : '/user',
    isAdmin: true
  },{
    title : 'Events',
    link : '/events',
    isAdmin: true
  },{
    title : 'Dashboard',
    link : '/dashboard',
    isAdmin: true
  },{
    title : 'Check out',
    link : '/check-out',
    isAdmin: false
  }
  ]
  
const settings = [{
  title : 'logout',
  link : 'logout'
}];

const MainMenu = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  function handleLogout() {
    clearLocalStorage();
    setUserData({})
  }
  const {userData,setUserData} = React.useContext(UserContext)

  return (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <SportsTennisIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'system-ui',
              fontWeight: 700,
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
{PROJECT_TITLE}
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page,i) => (
               ((page.isAdmin&&userData.isAdmin)||!page.isAdmin)&& <MenuItem key={i+'menu' }  component={Link} to={page.link}  onClick={handleCloseNavMenu}>
                  <Typography textAlign="center" sx={{fontFamily:'system-ui'}}>{page.title} </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <SportsTennisIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
          <Typography
            variant="h5"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            PADEL
          </Typography>
          <Box sx={{ flexGrow: 1,mr:5, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page,i) => (
              ((page.isAdmin&&userData.isAdmin)||!page.isAdmin)&&
              <Button
                key={i+'menus'}
                component={Link} to={page.link}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: 'white',fontFamily:'system-ui', display: 'block' }}
              >
                {page.title}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 0 }}>
          {userData.username && <span style={{fontFamily:'system-ui',fontSize:'14px'}}> hi, {userData.username}   </span>           }
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '20px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {settings.map((setting,i) => (
                setting.link=='logout'?<MenuItem    key={i} onClick={handleLogout}>
                <Typography textAlign="center">{setting.title}</Typography>
              </MenuItem>:
                <MenuItem  component={Link} to={setting.link}  key={i} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting.title}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default MainMenu;
